import { ElevationCallouts } from "./layout/ElevationCallouts/ElevationCallouts"
import { ElevationName } from "./layout/ElevationName/ElevationName"
import { ElevationNote } from "./layout/ElevationNote/ElevationNote"
import { NumberAndPage } from "./layout/NumberAndPage/NumberAndPage"
import { Objects } from "./layout/Objects/Objects"
import { TimesReferenced } from "./layout/TimesReferenced/TimesReferenced"
import type { TEcall, TErefWithFurniture, TFurniture } from "types/elevationReferences.type"

type Props = {
	eref: TErefWithFurniture
	ecalls: TEcall[]
	onCommitNote?: (note: string) => void
	onEcallClick?: (ecall: TEcall) => void
	onFurnitureClick?: (furniture: TFurniture) => void
	onDetachFurniture?: (furniture: TFurniture) => Promise<void>
	mismatchedFurnitureIds?: ReadonlySet<number>
}

export const DetailsTab = ({
	eref,
	ecalls,
	onCommitNote,
	onEcallClick,
	onFurnitureClick,
	onDetachFurniture,
	mismatchedFurnitureIds,
}: Props) => {
	return (
		<div>
			<NumberAndPage eref={eref} />
			<ElevationName eref={eref} />
			<TimesReferenced eref={eref} />
			<ElevationNote comment={eref.estimation_config_comment ?? ""} onCommit={onCommitNote} />
			<Objects
				eref={eref}
				onFurnitureClick={onFurnitureClick}
				onDetachFurniture={onDetachFurniture}
				mismatchedFurnitureIds={mismatchedFurnitureIds}
			/>
			<ElevationCallouts key={eref.id} eref={eref} ecalls={ecalls} onEcallClick={onEcallClick} />
		</div>
	)
}
